import { Divider, ListItem, ListItemIcon, ListItemText, useMediaQuery } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { Favorite as FavoriteIcon } from '@material-ui/icons'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import AttachmentIcon from '@material-ui/icons/Attachment'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import GetAppIcon from '@material-ui/icons/GetApp'
import NoteIcon from '@material-ui/icons/Note'
import ReceiptIcon from '@material-ui/icons/Receipt'
import React from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { mobileBreakpoint } from '../../../lib/helper/viewportHelper'
import { useLanguage } from '../../../lib/hooks/languageHooks'
import { strings as Localization } from '../../../lib/Localization'
import { useProxyPath } from '../../../redux/hook/settingsHooks'
import { signOut } from '../../../redux/userSlice'
import theme from '../../../theme'

const LinkListItem = (listItem) => {
    return (   
        <>
            <ListItemIcon>
                {listItem.icon}
            </ListItemIcon>
            <ListItemText primary={listItem.text}/>
        </>
    )
}

const StyledListItem = withStyles((theme) => ({
    root: {
        '&:focus': {
            backgroundColor: theme.palette.common.white,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.black,
            },
        },
        '& .MuiTypography-root': {
            '&:hover': {
                cursor: 'pointer',
                textDecoration: 'underline'
            }
        }
    },
}))(ListItem)


const ListOptions = ({ button }) => {
    const lang = useLanguage()
    const dispatch = useDispatch()
    const proxyPath = useProxyPath()
    const isMobile = useMediaQuery(theme.breakpoints.down(mobileBreakpoint))
    const linkList = [
        {linkType: "link", path: `${proxyPath}/${lang}/downloads`, target: "" , text: Localization.fileDownload, icon: <GetAppIcon fontSize='small' />},
        {linkType: "link", path: `${proxyPath}/${lang}/order-upload`, target: "" , text: Localization.orderByFile, icon: <AttachmentIcon fontSize="small" />},
        {linkType: "link", path: `${proxyPath}/${lang}/orders`, target: "" , text: Localization.yourOrders, icon: <ReceiptIcon fontSize="small" />},
        {linkType: "link", path: `${proxyPath}/${lang}/favorites`, target: "" , text: Localization.yourFavorites, icon: <FavoriteIcon fontSize="small" />},
        {linkType: "link", path: `${proxyPath}/${lang}/user`, target: "" , text: Localization.yourAccount, icon: <AccountCircleIcon fontSize="small" />},
    ]

    return (
        <>
            {linkList.map((el, index) => {
                return(
                    <StyledListItem 
                        style={{ 
                            width: (isMobile && !button) ? "50%" : "100%", 
                            textDecoration: isMobile ? 'underline' : 'none', 
                            color: theme.palette.common.black}} 
                            key={index} 
                            component={Link} 
                            to={el.path} 
                            dense
                        >
                        {LinkListItem(el)} 
                    </StyledListItem>
                )                    
            })  
            }
            {
                lang === 'sv' && (
                    <StyledListItem component={Link}
                        to={`${process.env.REACT_APP_IMAGE_URL}MAN-193.pdf`}
                        dense target={'_blank'} 
                        style={{
                            width: (isMobile && !button) ? "50%" : "100%",
                            textDecoration: isMobile ? 'underline' : 'none', 
                            color: theme.palette.common.black
                        }}
                    >
                        <ListItemIcon>
                            <NoteIcon fontSize='small' />
                        </ListItemIcon>
                        <ListItemText primary={Localization.returnNote} />
                    </StyledListItem>
                )
            }
            {
                button &&
                <Divider />
            }
            {
                <StyledListItem 
                    onClick={() => dispatch(signOut())} 
                    dense 
                    style={{
                        width: (isMobile && !button) ? "50%" : "100%", 
                        textDecoration: isMobile ? 'underline' : 'none', 
                        color: theme.palette.common.black
                    }}
                >
                    <ListItemIcon>
                        <ExitToAppIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary={Localization.logOut} />
                </StyledListItem>
            }
        </>
    )
}

export default ListOptions
